// These tokens have been deprecated. Use @optimizely/design-tokens instead.
export var brandBlueXLight = "hsla(226, 100%, 97%, 1)";
export var brandBlueLight = "hsla(227, 100%, 95%, 1)";
export var brandBlueBase = "hsla(227, 100%, 85%, 1)";
export var brandBlueDark = "hsla(227, 100%, 50%, 1)";
export var brandPurpleXLight = "hsla(240, 9%, 96%, 1)";
export var brandPurpleLight = "hsla(246, 11%, 82%, 1)";
export var brandPurpleBase = "hsla(240, 11%, 65%, 1)";
export var brandPurpleDark = "hsla(241, 77%, 12%, 1)";
export var smokeXLight = "hsla(0, 0%, 98%, 1)";
export var smokeLight = "hsla(0, 0%, 96%, 1)";
export var smokeBase = "hsla(0, 0%, 93%, 1)";
export var smokeDark = "hsla(0, 0%, 84%, 1)";
export var greyXLight = "hsla(0, 0%, 96%, 1)";
export var greyLight = "hsla(0, 0%, 85%, 1)";
export var greyBase = "hsla(0, 0%, 62%, 1)";
export var greyDark = "hsla(0, 0%, 44%, 1)";
export var purpleXLight = "hsla(263, 48%, 95%, 1)";
export var purpleLight = "hsla(263, 46%, 79%, 1)";
export var purpleBase = "hsla(263, 52%, 47%, 1)";
export var purpleDark = "hsla(263, 51%, 33%, 1)";
export var magentaXLight = "hsla(310, 56%, 94%, 1)";
export var magentaLight = "hsla(311, 56%, 75%, 1)";
export var magentaBase = "hsla(311, 95%, 37%, 1)";
export var magentaDark = "hsla(311, 94%, 26%, 1)";
export var pinkXLight = "hsla(340, 86%, 95%, 1)";
export var pinkLight = "hsla(341, 87%, 85%, 1)";
export var pinkBase = "hsla(340, 82%, 52%, 1)";
export var pinkDark = "hsla(341, 55%, 48%, 1)";
export var redXLight = "hsla(0, 91%, 96%, 1)";
export var redLight = "hsla(0, 89%, 83%, 1)";
export var redBase = "hsla(0, 89%, 57%, 1)";
export var redDark = "hsla(0, 67%, 45%, 1)";
export var orangeXLight = "hsla(36, 100%, 95%, 1)";
export var orangeLight = "hsla(36, 100%, 80%, 1)";
export var orangeBase = "hsla(36, 100%, 50%, 1)";
export var orangeDark = "hsla(36, 100%, 32%, 1)";
export var yellowXLight = "hsla(46, 100%, 95%, 1)";
export var yellowLight = "hsla(45, 100%, 80%, 1)";
export var yellowBase = "hsla(45, 100%, 51%, 1)";
export var yellowDark = "hsla(45, 96%, 43%, 1)";
export var greenXLight = "hsla(120, 38%, 95%, 1)";
export var greenLight = "hsla(123, 38%, 80%, 1)";
export var greenBase = "hsla(122, 39%, 49%, 1)";
export var greenDark = "hsla(122, 39%, 34%, 1)";
export var aquaXLight = "hsla(189, 72%, 94%, 1)";
export var aquaLight = "hsla(187, 73%, 77%, 1)";
export var aquaBase = "hsla(187, 100%, 42%, 1)";
export var aquaDark = "hsla(187, 100%, 27%, 1)";
export var blueXLight = "hsla(209, 91%, 95%, 1)";
export var blueLight = "hsla(207, 89%, 82%, 1)";
export var blueBase = "hsla(207, 90%, 54%, 1)";
export var blueDark = "hsla(207, 77%, 38%, 1)";
export var white = "hsla(0, 0%, 100%, 1)";
export var black = "hsla(0, 0%, 0%, 1)";
export var iconSmall = "12px";
export var iconLarge = "16px";
export var nubbinSize = "24px";
